import posthog from 'posthog-js'

/**
 * Hook to access PostHog functionality
 * @returns PostHog instance
 */
export const usePostHog = () => {
  return posthog
}

/**
 * Track a custom event
 * @param eventName - Name of the event to track
 * @param properties - Optional properties to attach to the event
 */
export const trackEvent = (
  eventName: string,
  properties?: Record<string, any>,
) => {
  if (posthog.__loaded) {
    posthog.capture(eventName, properties)
  }
}

/**
 * Identify a user in PostHog
 * @param userId - Unique identifier for the user
 * @param properties - Optional user properties
 */
export const identifyUser = (
  userId: string,
  properties?: Record<string, any>,
) => {
  if (posthog.__loaded) {
    posthog.identify(userId, properties)
  }
}

/**
 * Reset PostHog user identification (typically on logout)
 */
export const resetUser = () => {
  if (posthog.__loaded) {
    posthog.reset()
  }
}
